import React, { useState, useEffect, useRef } from 'react';
import { PageHeader, Tabs, Space, Input, Button, message, Spin } from 'antd';
import { PageGrid } from '@/component';
import { PlusOutlined, EditOutlined } from '@/icons';
import { getColumns } from './tagColumns';
import TagFormModal from './TagFormModal';
import { syncCorpTag } from '@/api/customer';
import styles from '../index.module.less';
import classNames from 'classnames';
import {useEditAuthService} from '@/page/admin/adminService';

const { TabPane } = Tabs;
export default function CustomerTagPage() {
    const editable = useEditAuthService(['global:customer_tag:w']);
    const formModalRef = useRef();
    const tableRef = useRef();
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(false);


    let extra = (
        <Input.Group compact>
            <Button type="primary" icon={<PlusOutlined />} onClick={onAddClick} disabled={!editable}>
                添加
            </Button>
            {/* <Button
                type="primary"
                icon={<SyncOutlined />}
                style={{ marginLeft: '10px' }}
                onClick={sync}
            >
                同步
            </Button> */}
        </Input.Group>
    );

    let columns = getColumns([
        'groupId',
        'groupName',
        'tags',
    ]);
    columns.push({
        title: '操作',
        dataIndex: 'action',
        align:'center',
        render: (text, record) => (
            <Space>
                <Button
                    disabled={!editable}
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => onModifyClick(record)}
                    style={{ color: '#152D85' }}
                >
                    编辑
                </Button>
            </Space>
        ),
    });
    useEffect(() => {
        setUrl('/customer/corptag/list');
    }, []);

    function onAddClick() {
        formModalRef.current.showModal();
    }

    function onModifyClick(record) {
        formModalRef.current.showModal(record);
    }

    function refreshTable() {
        tableRef.current.refresh();
    }

    function sync() {
        setLoading(true);
        let params = {
            "tag_id": [],
            "group_id": []
        }
        syncCorpTag(params).then(res => {
            setLoading(false);
            message.success('同步成功');
            refreshTable();
        });
    }

    function renderTabs() {
        return (
            <div className={classNames(styles.tableContainer, styles.tabContainer)}>
                <Tabs className={styles.tabs}>
                    <TabPane tab="企业客户标签" key="0">
                        <Spin spinning={loading} >
                            {url && (
                                <PageGrid
                                    ref={tableRef}
                                    url={url}
                                    columns={columns}
                                />
                            )}
                        </Spin>
                    </TabPane>
                </Tabs>
            </div>
        );
    }

    return (
        <div style={{ overflowY: 'auto' }} >
            <div className={styles.header}>
                <PageHeader  title={'客户标签管理'} extra={extra} />
            </div>
            {renderTabs()}
            <TagFormModal ref={formModalRef} reloadGroups={refreshTable} />
        </div>
    );

}
